import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowDownRound = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.707 12.293a1 1 0 1 0-1.414 1.415l5.006 5a1 1 0 0 0 1.414-.001l4.995-5a1 1 0 1 0-1.415-1.414L13 15.59V5.211a1 1 0 1 0-2 0v10.371l-3.293-3.29Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowDownRound);
export default Memo;
